/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
 import {  Component, ViewChild, ChangeDetectorRef, ViewChildren, QueryList, OnInit} from '@angular/core';
 import {MessageService, Message} from 'primeng/api';
 import { ApiService } from '../../shared/api.service';
 import { CountriesService } from '../../@core/data/countries.service';
 import { FormBuilder, FormControl, FormGroup,Validators} from '@angular/forms';
 import { NbDateService,NbDialogService,NbToastrService, NbGlobalPhysicalPosition, NbDialogRef } from '@nebular/theme';
 import { TermsComponent } from './terms.component';
 import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
 import {ConfirmationService} from 'primeng/api';
 import { ConfirmPassComponent } from './confirmPass.component';
 import { Router } from '@angular/router';
 import { MatStepper, MatSelectChange, MatAutocompleteTrigger } from '@angular/material';
 //import { MatRadioModule } from '@angular/material';
 import { config } from './../../../../config';
 import { EducationalFormComponent } from './../../apply/dialog/educationalform.component';
 import { previewImg } from './../../apply/dialog/transcriptpreview.component';
 import { PaymentModelComponent } from './../../payment-success/payment.component';
 import { TranscriptDialogComponent } from './../../pages/myapplications/applicationsteps/dialog/transcriptdialogcomponent';
 import { saveAs } from 'file-saver';
 import {
	 NbAuthService,
	 NbAuthJWTToken
   } from '@nebular/auth';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
 
 @Component({
   selector: 'nb-register',
   styleUrls: ['./register.component.scss'],
   templateUrl: './register.component.html',
   providers: [MessageService, ConfirmationService]
 })
 export class RegisterComponent{
	 
	 @ViewChild('stepper') stepper: MatStepper;
	 @ViewChildren(MatAutocompleteTrigger) autoComplete: QueryList<MatAutocompleteTrigger>;
	 serverUrl = config.serverUrl;
	 imageUrl = config.imageUrl;
	 helpEmailId = "";
	 user_id
	 email:any;
	 alertflag = 0;///this is for  submit button
	 messgealertflag = 0;
	 messages;
	 validation_messages;
	 captcha;
	 captchaText;
	 values = '';
	 emailAlert = false;
	 display: boolean = false;
	 displayNo: boolean = false;
	 displayPrnNo: boolean = false;
	 prnValidation: boolean = false;
	 emailValue;
 
	 Countries: any [];
	 selectedCountry :any;
	 permCountry:any;
 
	//  readonly emailValidate = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	//  readonly charValidate = /^[.a-zA-Z ]*$/;
	//  readonly spaceValidate = /^[.a-zA-Z]*$/;
	//  readonly postalValidate = /^[a-zA-Z0-9]+$/;
	//  readonly mobileValidate =/^[0-9]\d{5,12}$/;
	//  readonly numberpattern = /^[-+]?[0-9]+$/ ;
	//  readonly passwordValidate = /^[A-Za-z0-9!@#$%^&*()_]{6,}$/;
	//  readonly nospace = /^(?! )[A-Za-z ]*(?<! )$/;
 
	 //NEW REG
	 isLinear = false;
	 firstFormGroup : FormGroup;

	 myControlCourse = new FormControl('',Validators.required);
	 filteredOptionCourses: Observable<string[]>;
	 arr = 'https://solmigration.studentscenter.in/api/sample/Instructions_Migration_Certificate.pdf';
	 course_data: any[];
	 duration: any;
	 course_name: any;
	 showInstruction: boolean;
	 inputObj: any;
	 country_codeL: any;
	 current_date: string;
	 specialCharError: boolean;
	 country_code: any;
	 country_name: any;
	 countryCode: any;
	 prnNoValidationError: boolean;
	 svg: SafeHtml;
	 gender: any;
	 screenWidth: any;
	 screenHeight: any;
	 degree_type: any;
	 
	   constructor(
	
		 private fb: FormBuilder,
		 protected dateService: NbDateService<Date>,
		 protected api : ApiService,
		 protected countries :CountriesService,
		 private dialogService: NbDialogService, //on submit dialog box
		 private messageService: MessageService,
		 private toastrService: NbToastrService,
		 private sanitizer: DomSanitizer,
		 private confirmationService: ConfirmationService,
		 private router : Router,
		 private ref: ChangeDetectorRef,
		 private authService: NbAuthService,
	 ){  
		 this.Countries = this.countries.getData();
	 }
	 
	 ngOnInit() {
		// this.showInstruction = true;
		this.screenWidth = window.innerWidth;
    	this.screenHeight = window.innerHeight;
		if (this.screenWidth<=750) {
			this.showInstruction=false;
			var path = '/var/www/public/sample/Instructions_Migration_Certificate.pdf'
			this.api.downloadDocument(path)
			.subscribe(data1 => {
			  var file_name = 'Migration_Manual.pdf';
			  saveAs(data1,file_name );  
			});
		}
		
		if(this.inputObj){
			this.inputObj.setCountry(this.country_codeL);
		 }
		 this.getCourse();
 
		 this.api.getCaptcha().subscribe((data: any) => {  
			 this.captchaText = data['data']['captchaText'];
			 this.captcha =  data['data']['captchadata'];
			 this.svg = this.sanitizer.bypassSecurityTrustHtml(this.captcha);         
			 err => console.error(err)
		 });
 
		 //NEW
		 this.firstFormGroup = this.fb.group({
			 fullNameCtrl: ['', [Validators.required, Validators.maxLength(70),Validators.minLength(1)]], //Validators.pattern(this.charValidate),
			 FirstNameCtrl: ['', [Validators.required, Validators.maxLength(70),Validators.minLength(1)]],
			//  stud_fatherCtrl:['', [Validators.required, Validators.maxLength(70),Validators.minLength(1)]],
			 lastNameCtrl: [],
			 input_prn : [''],
			 phoneCtrl:['', [ Validators.required ]], //, Validators.pattern(this.mobileValidate)
			 genderCtrl: ['', Validators.required],
			 captchaCtrl:['', Validators.required],
			 emailCtrl : ['', [ Validators.required ]], //Validators.pattern(this.emailValidate)
			 passwordCtrl : ['',[Validators.required ]], //, Validators.pattern(this.passwordValidate)
			 repasswordCtrl : ['',[Validators.required ]],
			 aadharCtrl : ['',[Validators.required, Validators.maxLength(12),Validators.minLength(6) ]],
			//  myControlCourse : ['',[Validators.required]]
		 });

	 }

	 getCourse(){
		 this.api.getCourses().subscribe((data)=>{
			if(data['status'] == 200){
				this.course_data = data['data'];
				// console.log("this.course_data",this.course_data);
				this.filteredOptionCourses = this.myControlCourse.valueChanges.pipe(
					startWith(''),
					map(value => this._filterCourse(value || '')),// map(value => this._filterCourse(value))
				  );
			  }else{
	  
			  }
		 })
	 }

	 private _filterCourse(value: string){
	 const filterValue = this._normalizeValue(value);
	 return this.course_data.filter(option => this._normalizeValue(option.course_name).includes(filterValue)); 	 
   	}

   private _normalizeValue(value: string): string {
    if(value){
      return value.toLowerCase().replace(/\s/g, '');
    }else{
      return '';
    }
  }

	 capitalize(text_value){
		 var text = text_value;
		 text = text.toLowerCase()
			 .split(' ')
			 .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
			 .join(' ');
		 return text;
	 }

	 OnlyNoAllowed(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		  this.specialCharError = true;
		  console.log("CharCode restricted is " + charCode);
		  return false;
		}
		return true;
	  }

	  telInputObject(obj) {
		this.api.getIpAddress().subscribe(data => {
			this.country_name = data['country'];
			this.country_code=data['country_code'];
			var code =data['country_calling_code'];
			var code1 = code.replace("+","")
			this.countryCode = code1;			
			this.country_codeL=this.country_code.toLowerCase();
			this.inputObj = obj;
			this.inputObj.setCountry(this.country_codeL);
		
		})
	  }
	 
 
	 reloadcaptcha(){
		 this.api.getCaptcha()
		 .subscribe(
			 (data: any) => {  
			 this.captchaText = data['data']['captchaText'];
			 this.captcha =  data['data']['captchadata'];
			 this.svg = this.sanitizer.bypassSecurityTrustHtml(this.captcha);         
			 err => console.error(err)
		 });
	 }
 
	 checkcaptcha(){
		 if(!(this.firstFormGroup.controls.captchaCtrl.value == this.captchaText)){		
			 this.toastrService.danger(       
				 `checkcaptcha doesn't match ! ! `, 'Error'
			   );
			 this.validation_messages =  "checkcaptcha doesn't match!";
			 this.firstFormGroup.controls.captchaCtrl.markAsDirty();
			 
		 }
	 }
 
	 checkpassword(duration,status){
		status = 'Error!!';
		 if(this.firstFormGroup.controls.passwordCtrl.value != this.firstFormGroup.controls.repasswordCtrl.value){		
 
			 this.toastrService.danger(       
				 'Password doesnt match ! ! ', 'Error'
			   );
			 this.validation_messages =  "Password doesn't match!";
			 this.firstFormGroup.controls.passwordCtrl.markAsDirty();
		 }
	 }
 
	 onClose(){
		 this.messgealertflag = 0;
	 }
 
	 onEmailClose(){
		 this.emailAlert = false;
	 }
 
	 close() {
		 this.alertflag = 0;
		 this.showInstruction = false
	 }
 
	 //to check which form control is invalid
	 public findInvalidControls(controls) {
		 const invalid = [];
		
		 for (const name in controls) {
			 if (controls[name].invalid) {
				 invalid.push(name);
			 }
		 }
		 return invalid;
	   }
 
	 onProceed(duration,status){
		status = 'Error!!!'
		var check_validation; 
		 var error=this.findInvalidControls(this.firstFormGroup.controls)
		 
		 if(this.firstFormGroup.controls.passwordCtrl.value == this.firstFormGroup.controls.repasswordCtrl.value){
			 if(this.firstFormGroup.valid){	
				 if(this.firstFormGroup.controls.captchaCtrl.value == this.captchaText){	
					 check_validation = true;
					 this.alertflag = 0;
				 }else{
					 this.reloadcaptcha();
					 this.toastrService.danger(       
						 `checkcaptcha doesn't match ! ! `, 'Error',
					 );	
				 }			
			 }else{		console.log("eler==>");
			 	
				 this.reloadcaptcha();			
				 check_validation = false;
				 this.alertflag = 1;
				 this.validation_messages =  "Fill in the all required details !";
			 }
		 }else{
			 this.alertflag = 1;
			 this.toastrService.danger(       
				 `Password doesn't match ! ! `, 'Error'
			 );
			 this.validation_messages =  "Password doesn't match!";
 
		 }
 
		 var phonecode = this.countryCode;
		 console.log("check_validation==>",check_validation);
		 console.log("error==>",error);
		 
		 
		 console.log("This is Country Code with Mobile Number",this.firstFormGroup.controls.phoneCtrl.value);
		 console.log("this is only country code"+this.countryCode);
		 if(check_validation){			 
			 this.dialogService.open(TermsComponent, {
				 context: {
					 FirstName : this.firstFormGroup.controls.FirstNameCtrl.value,
					 LastName : this.firstFormGroup.controls.lastNameCtrl.value,
					 userName : this.firstFormGroup.controls.fullNameCtrl.value,
					//  stud_fathernameCtrl : this.firstFormGroup.controls.stud_fatherCtrl.value,
					 Gender : this.gender ? this.gender : this.firstFormGroup.controls.genderCtrl.value,
					 inputprn : this.firstFormGroup.controls.input_prn.value,
					 userEmail : this.firstFormGroup.controls.emailCtrl.value,
					 userPassword : this.firstFormGroup.controls.passwordCtrl.value,
					 userContactNo : this.firstFormGroup.controls.phoneCtrl.value,
					 aadhar : this.firstFormGroup.controls.aadharCtrl.value,
					 course_name : this.course_name,
					 degree_type :this.degree_type,
    				 userCountryCode: this.countryCode					 
				 },
			 }).onClose
			 .subscribe(
				 (user_id : any) => {
					 if(user_id){
						 this.user_id = user_id;
						this.router.navigate(['./auth/login'])
					 }
				 }
			 );
		 }else{
			 this.alertflag = 1;
			 if(this.validation_messages != null){
				 this.messages = this.validation_messages;
			 }else{
				 this.messages = "Your form is not filled please fill completely";
			 }
		 }
 
	 }
 
	 onKeyPress(event: any) {
		 this.emailAlert = false;		
		 this.api.emailValues(this.firstFormGroup.controls.emailCtrl.value)
			 .subscribe(
				 (data: any) => {
				 if(data['status'] == 400){  
					 this.confirmationService.confirm({
						 message: 'Your email id is already exists in our database!!! Do you want to login on this website using same id and password??',
						 header: 'Confirmation',
						 icon: 'pi pi-exclamation-triangle',
						 accept: () => {
							 this.display = true;						
						 },
						 reject: () => {
							 this.emailValue = this.firstFormGroup.controls.emailCtrl.value;
							 this.displayNo = true;
						 }
					 });
				 }else{
				 }       
				 err => console.error(err)
			 });
	 };
 
	 downloadLetter(){
		 var file_name = 'NOC letter.pdf'
		 this.api.downloadTemplate().subscribe(data => {
			 saveAs(data,file_name); 
		 })
	 }
 
	 onKeyPressPRN(event: any) {
	 
		if(this.firstFormGroup.controls.input_prn.value.length>16||this.firstFormGroup.controls.input_prn.value.length<12){
		
			this.prnNoValidationError=true
		 }else{
			 this.prnNoValidationError=false
		 }
		 this.api.prnValues(this.firstFormGroup.controls.input_prn.value)
			 .subscribe(
				 (data: any) => {console.log("status",data);
				 
				 if(data['status'] == 400){ 
					 this.prnValidation = true; 
					 var data = data['data'];
					 this.confirmationService.confirm({
						 message: 'Your PRN/Confirmation/Reg. number is already exists in our database!!! Do you want to login on this website using same id and password??',
						 header: 'Confirmation',
						 icon: 'pi pi-exclamation-triangle',
						 accept: () => {
							 this.display = true;	
							 this.emailValue = data.email;
						 },
						 reject: () => {
							 this.emailValue = data.email;
							 this.displayPrnNo = true;
						 }
					 });
				 }else{
					 this.prnValidation = false; 
				 }       
				 err => console.error(err)
			 });
	 };
  
	 onCountryChange(details){
		 this.countryCode = details.dialCode;
		//  console.log("codeee",this.countryCode);
		 
	 }


	OnlyCharAllowed(event):boolean{
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode < 48 || charCode > 31 || charCode > 96 || charCode < 105) {
          return false;
        }
        return true;
      }

	  selectCourse(event, name, part_name,degree_type){
		
		if (event.isUserInput) { 
		//   this.firstFormGroup.controls.myControlCourse.setValidators([]);
		//   this.firstFormGroup.controls.myControlCourse.updateValueAndValidity();
		  this.duration = part_name;
		  this.course_name = name;
		  this.degree_type = degree_type
		}
	  }

	  onChange(event){
		this.gender = event;
	  }
 }